import React from 'react';

import { ClassDetail } from './ClassDetail';
import ClassContainer from '../../../ClassModal/ClassContainer';

const ClassPage: React.FC = () => (
    <ClassContainer.Provider>
        <ClassDetail />
    </ClassContainer.Provider>
);
export default ClassPage;
